/**
 * @file ShopMonogram.tsx
 * @description Плитка-монограмма магазина (phase19.31, SC19): две буквы
 * названия на «цвете магазина» из фиксированного набора по id
 * (`lib/shop-monogram`). Логотип вместо монограммы — позже, вместе с
 * Конструктором 2.0.
 *
 * Цвет плитки — данные набора (как метки стадий), а не токен темы: магазин
 * не должен менять цвет вместе с темой кабинета. Поэтому он задаётся
 * `style`, а не классом.
 */

import { shopInitials, shopMonogramColor } from "../../lib/shop-monogram";
import { cn } from "@/lib/utils";

interface Props {
  shopId: string;
  name: string;
  /** Сторона плитки в пикселях: 32 — шапка панели, 24 — верхняя панель. */
  size?: 24 | 32;
  className?: string;
}

const SIZE_CLASS: Record<NonNullable<Props["size"]>, string> = {
  24: "size-6 rounded-md text-xs",
  32: "size-8 rounded-lg text-sm",
};

export function ShopMonogram({ shopId, name, size = 32, className }: Props) {
  return (
    <span
      aria-hidden
      data-testid="shop-monogram"
      className={cn(
        "inline-flex shrink-0 select-none items-center justify-center font-semibold text-white",
        SIZE_CLASS[size],
        className,
      )}
      style={{ backgroundColor: shopMonogramColor(shopId) }}
    >
      {shopInitials(name)}
    </span>
  );
}
